import * as React from "react";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps
} from "@mui/material/CircularProgress";

const CircularLoader =(props)=>{

  return (

    <Backdrop
    sx={{flexDirection:'column',gap:'1rem', backgroundColor: 'rgba(100, 102, 106,0.5)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={true}
  >
    <Box sx={{ position: "relative" }}>
    <CircularProgress
      variant="determinate"
      sx={{
        color: (theme) =>
          theme.palette.grey[theme.palette.mode === "light" ? 300 : 700]
      }}
      size={40}
      thickness={4}
      {...props}
      value={100}
    />
    <CircularProgress
      variant="indeterminate"
      disableShrink
      sx={{
        color: (theme) =>
          theme.palette.mode === "light" ? "#cf2030" : "#308fe8",
        animationDuration: "550ms",
        position: "absolute",
        left: 0,
        [`& .${circularProgressClasses.circle}`]: {
          strokeLinecap: "round"
        }
      }}
      size={40}
      thickness={4}
      {...props}
    />
  </Box>
  </Backdrop>
  );
}

export default CircularLoader;